<template>
    <span
        class="card-challenge-status-text-incomplete"
        :class="statusClass">{{ statusText }}</span>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        props: {
            resultItem: {
                type: Object,
                default: {
                    id: 8,
                    status: "ONGOING",
                    user1: {
                        id: 1,
                        username: "temren",
                        status: "DONE-PRACTICE"
                    },
                    user2: {
                        id: 3,
                        username: "kral1790",
                        status: "WAIT-PRACTICE"
                    }
                }
            },
        },

        computed: {
            statusText(){
                let curUserType = this.$store.state.challengeSession.userType;
                let rivalUserType = null;
                
                if(curUserType === 1){
                    rivalUserType = 'user' + 2;
                }
                else if(curUserType === 2){
                    rivalUserType = 'user' + 1;
                }

                if(this.resultItem[rivalUserType].status === 'WAIT-ANSWER'){
                    return 'Rakibin isteğini henüz cevaplamadı.';
                }
                else if(this.resultItem[rivalUserType].status === 'REJECTED'){
                    return 'Rakibin isteğini reddetti.';
                }
                else if(this.resultItem[rivalUserType].status === 'WAIT-PRACTICE'){
                    return 'Rakibin pratik oturumuna alındı.';
                }
            },

            statusClass(){
                let curUserType = this.$store.state.challengeSession.userType;
                let rivalUserType = null;
                
                if(curUserType === 1){
                    rivalUserType = 'user' + 2;
                }
                else if(curUserType === 2){
                    rivalUserType = 'user' + 1;
                }

                return 'card-challenge-status-text-incomplete--' + this.resultItem[rivalUserType].status.toLowerCase();
            }
        }
    };
</script>

<style scoped src="@/css/components/card-challenge-status-text-incomplete.css"></style>